<div class="container pt-3 pt-sm-4">
	<!-- announcements -->
	<div class="row">
		<div class="col">
			<app-announcements />
		</div>
	</div>

	<!-- forum -->
	<app-forum />
</div>
